<div class="single-select-wrapper relative" [class]="styleClass" [class.dropdown-open]="isOpen">
  <div 
    class="single-select-trigger w-full min-w-[200px] bg-white cursor-pointer transition-all duration-200 relative"
    [class.opacity-50]="disabled"
    [class.cursor-not-allowed]="disabled"
    (click)="toggleDropdown()"
  >
    <div class="flex items-center justify-between">
      <div class="flex-1 flex flex-wrap gap-2 min-h-[24px] items-center">
        <!-- Placeholder when no item selected -->
        <span 
          *ngIf="!selectedValue" 
          class="text-gray-500 text-sm"
        >
          {{ placeholder }}
        </span>
        
        <!-- Show chip when item is selected -->
        <span
          *ngIf="selectedValue"
          class="inline-flex items-center gap-1.5 px-2.5 py-1.5 bg-[#00d084] text-white text-xs font-medium rounded-md shadow-sm hover:bg-[#00b875] transition-colors"
        >
          <span class="flex-shrink-0">{{ getDisplayValue() }}</span>
          <svg
            *ngIf="showClear && !disabled"
            class="w-3 h-3 cursor-pointer hover:text-gray-200 transition-colors"
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
            (click)="clearSelection($event); $event.stopPropagation()"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </span>
      </div>
      
      <div class="flex items-center gap-2 flex-shrink-0 ml-2">
        <!-- Caret icon -->
        <svg 
          class="w-5 h-5 text-gray-500 transition-transform duration-200"
          [class.rotate-180]="isOpen"
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
        </svg>
      </div>
    </div>
  </div>

  <!-- Dropdown Panel -->
  <div
    *ngIf="isOpen && options && options.length > 0"
    class="dropdown-panel absolute w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-xl max-h-60 overflow-auto"
    style="top: 100%; left: 0; min-width: 200px;"
    (click)="$event.stopPropagation()"
  >
    <!-- Options List -->
    <div class="py-1">
      <div
        *ngFor="let option of options; trackBy: trackByOption"
        [class]="getOptionClasses(option)"
        (click)="selectOption(option)"
      >
        <!-- Checkbox -->
        <div class="flex items-center mr-3 flex-shrink-0">
          <input
            type="checkbox"
            [checked]="isSelected(option)"
            class="w-4 h-4 checkbox-custom border-gray-300 rounded focus:ring-2 cursor-pointer"
            (click)="$event.stopPropagation(); selectOption(option)"
            readonly
          />
        </div>
        
        <!-- Option Label -->
        <span 
          class="text-sm text-gray-700 flex-1"
          [class.text-[#00d084]]="isSelected(option)"
          [class.font-medium]="isSelected(option)"
        >
          {{ getOptionLabel(option) }}
        </span>
      </div>
      
      <div *ngIf="options.length === 0" class="px-3 py-2 text-sm text-gray-500 text-center">
        No options available
      </div>
    </div>
  </div>
</div>
